<template>
  <div class="bar-c">
    <div class="bar-1 bar" :class="{'noAnim': !playing}"></div>
    <div class="bar-2 bar" :class="{'noAnim': !playing}"></div>
    <div class="bar-3 bar" :class="{'noAnim': !playing}"></div>
    <div class="bar-4 bar" :class="{'noAnim': !playing}"></div>
    <div class="bar-5 bar" :class="{'noAnim': !playing}"></div>
    <div class="bar-6 bar" :class="{'noAnim': !playing}"></div>
  </div>
</template>

<script>
export default {
  name: 'SoundIconWithAnimation',
  props: {
    playing: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-c {
  overflow: hidden;
  height: 20px;
  width: 20px;
  position: relative;
  cursor: pointer;
}

.cblack .bar {
  background-color: #000;
}

.bar {
  height: 2px;
  width: 1px;
  display: inline-block;
  background-color: #ffffd2;
  bottom: 0;
  position: absolute;

  animation-duration: 500ms;
  animation-play-state: running;
  animation-direction: alternate;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  &.noAnim {
    animation: none;
    animation-name: none;
  }

  &.bar-1 {
    left: 0;
    animation-name: danceHeight1;
    animation-delay: 0ms;
  }

  &.bar-2 {
    left: 3px;
    animation-name: danceHeight2;
    animation-delay: 300ms;
  }

  &.bar-3 {
    left: 6px;
    animation-name: danceHeight3;
    animation-delay: 600ms;
  }

  &.bar-4 {
    left: 9px;
    animation-name: danceHeight4;
    animation-delay: 900ms;
  }

  &.bar-5 {
    left: 12px;
    animation-name: danceHeight5;
    animation-delay: 1200ms;
  }

  &.bar-6 {
    left: 15px;
    animation-name: danceHeight6;
    animation-delay: 1500ms;
  }
}

@keyframes danceHeight1 {
  from { height: 1px; }
  to { height: 12px; }
}
@keyframes danceHeight2 {
  from { height: 1px; }
  to { height: 15px; }
}
@keyframes danceHeight3 {
  from { height: 1px; }
  to { height: 20px; }
}
@keyframes danceHeight4 {
  from { height: 1px; }
  to { height: 20px; }
}
@keyframes danceHeight5 {
  from { height: 1px; }
  to { height: 15px; }
}
@keyframes danceHeight6 {
  from { height: 1px; }
  to { height: 15px; }
}
</style>
